var sidebarMenu = jQuery('#sidebar').find('.menu');

var menuCounter = sidebarMenu.find('>li.menu-item').length;
sidebarMenu.find('>li.menu-item').each(function (k, v) {
    // console.log(k, v);
    var categoryBlockMenu = jQuery(v);
    // console.log(categoryBlockMenu.find('ul.sub-menu'));
    if (categoryBlockMenu.find('ul.sub-menu').length > 0) {
        categoryBlockMenu.find('ul.sub-menu').addClass('collapse');
        categoryBlockMenu.find('ul.sub-menu').attr('id', 'collapseSidebarMenu'+k);

        var changeMinus = '';
        if (categoryBlockMenu.hasClass('current-menu-parent') || categoryBlockMenu.hasClass('current-menu-item') || categoryBlockMenu.hasClass('current-product-ancestor')) {
            categoryBlockMenu.find('ul.sub-menu').addClass('in');
            changeMinus = 'change-minus';
        }

        categoryBlockMenu.append('' +
            '<button class="btn btn-primary '+changeMinus+'" type="button" data-toggle="collapse-menu" data-target="#collapseSidebarMenu'+k+'" aria-expanded="false" aria-controls="collapseSidebarMenu'+k+'">' +
                '<em class="fa fa-plus"></em>' +
            '</button>');

    } else {

    }

    if (!--menuCounter) {
        setTimeout(function () {
            jQuery('button[data-toggle="collapse-menu"]').click(function () {
                jQuery(jQuery(this).attr('data-target')).toggleClass('in');
                jQuery(this).toggleClass('change-minus');
            });
        }, 1000);
    }
});

if (jQuery('body').hasClass('woocommerce-cart')) {
    jQuery(document).on('change paste keyup', 'input.input-text.qty.text', function () {
        jQuery('.checkout-button').addClass('d-none');
        jQuery('.fusion-update-cart').removeClass('d-none');
    });
}

if (jQuery('.products.related').find('.product').length == 0) {
    jQuery('#related-title').remove();
}